import { useContext, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { MyContext } from '../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';

const PaymentRes = () => {

    const { setPaymentRes, BookRef } = useContext(MyContext);

    const location = useLocation();
    const navigate = useNavigate();

    const DataRef = useRef(false);

    useEffect(() => {
        if (DataRef.current) return;
        DataRef.current = true;
        const queryParams = new URLSearchParams(location.search);
        const status = queryParams.get('status');
        const transactionId = queryParams.get('transactionId');
        if (status == "true") {
            setPaymentRes("PaymentDone");
            if (transactionId) {
                sessionStorage.setItem("transactionid", transactionId);
            }
            BookRef.current = false;
        } else {
            setPaymentRes("PaymentFaild");
        }
        const Page = secureLocalStorage.getItem("Page");
        navigate(`/${Page}`);
    }, [location.search]);


    return null;
}

export default PaymentRes